import deAssistant from '../locales/de-DE/assistant.json';
import deBorderlands3SkillTrees from '../locales/de-DE/borderlands_3_skill_trees_localization.json';
import deCommon from '../locales/de-DE/common.json';
import deDesktop from '../locales/de-DE/desktop.json';
import deGameMap from '../locales/de-DE/game_map.json';
import deGameTools from '../locales/de-DE/game_tools.json';
import deLabs from '../locales/de-DE/labs.json';
import deMobileMaps from '../locales/de-DE/mobile_maps.json';
import deUi from '../locales/de-DE/ui.json';
import deVideo from '../locales/de-DE/video.json';
import deWebsite from '../locales/de-DE/website.json';
import deWiki from '../locales/de-DE/wiki.json';
import enAssistant from '../locales/en-US/assistant.json';
import enBorderlands3SkillTrees from '../locales/en-US/borderlands_3_skill_trees_localization.json';
import enCommon from '../locales/en-US/common.json';
import enDesktop from '../locales/en-US/desktop.json';
import enGameMap from '../locales/en-US/game_map.json';
import enGameTools from '../locales/en-US/game_tools.json';
import enLabs from '../locales/en-US/labs.json';
import enMobileMaps from '../locales/en-US/mobile_maps.json';
import enUi from '../locales/en-US/ui.json';
import enVideo from '../locales/en-US/video.json';
import enWebsite from '../locales/en-US/website.json';
import enWiki from '../locales/en-US/wiki.json';
import esAssistant from '../locales/es-ES/assistant.json';
import esBorderlands3SkillTrees from '../locales/es-ES/borderlands_3_skill_trees_localization.json';
import esCommon from '../locales/es-ES/common.json';
import esDesktop from '../locales/es-ES/desktop.json';
import esGameMap from '../locales/es-ES/game_map.json';
import esGameTools from '../locales/es-ES/game_tools.json';
import esLabs from '../locales/es-ES/labs.json';
import esMobileMaps from '../locales/es-ES/mobile_maps.json';
import esUi from '../locales/es-ES/ui.json';
import esVideo from '../locales/es-ES/video.json';
import esWebsite from '../locales/es-ES/website.json';
import esWiki from '../locales/es-ES/wiki.json';
import frAssistant from '../locales/fr-FR/assistant.json';
import frBorderlands3SkillTrees from '../locales/fr-FR/borderlands_3_skill_trees_localization.json';
import frCommon from '../locales/fr-FR/common.json';
import frDesktop from '../locales/fr-FR/desktop.json';
import frGameMap from '../locales/fr-FR/game_map.json';
import frGameTools from '../locales/fr-FR/game_tools.json';
import frLabs from '../locales/fr-FR/labs.json';
import frMobileMaps from '../locales/fr-FR/mobile_maps.json';
import frUi from '../locales/fr-FR/ui.json';
import frVideo from '../locales/fr-FR/video.json';
import frWebsite from '../locales/fr-FR/website.json';
import frWiki from '../locales/fr-FR/wiki.json';
import hiAssistant from '../locales/hi-IN/assistant.json';
import hiBorderlands3SkillTrees from '../locales/hi-IN/borderlands_3_skill_trees_localization.json';
import hiCommon from '../locales/hi-IN/common.json';
import hiDesktop from '../locales/hi-IN/desktop.json';
import hiGameMap from '../locales/hi-IN/game_map.json';
import hiGameTools from '../locales/hi-IN/game_tools.json';
import hiLabs from '../locales/hi-IN/labs.json';
import hiMobileMaps from '../locales/hi-IN/mobile_maps.json';
import hiUi from '../locales/hi-IN/ui.json';
import hiVideo from '../locales/hi-IN/video.json';
import hiWebsite from '../locales/hi-IN/website.json';
import hiWiki from '../locales/hi-IN/wiki.json';
import idAssistant from '../locales/id-ID/assistant.json';
import idBorderlands3SkillTrees from '../locales/id-ID/borderlands_3_skill_trees_localization.json';
import idCommon from '../locales/id-ID/common.json';
import idDesktop from '../locales/id-ID/desktop.json';
import idGameMap from '../locales/id-ID/game_map.json';
import idGameTools from '../locales/id-ID/game_tools.json';
import idLabs from '../locales/id-ID/labs.json';
import idMobileMaps from '../locales/id-ID/mobile_maps.json';
import idUi from '../locales/id-ID/ui.json';
import idVideo from '../locales/id-ID/video.json';
import idWebsite from '../locales/id-ID/website.json';
import idWiki from '../locales/id-ID/wiki.json';
import itAssistant from '../locales/it-IT/assistant.json';
import itBorderlands3SkillTrees from '../locales/it-IT/borderlands_3_skill_trees_localization.json';
import itCommon from '../locales/it-IT/common.json';
import itDesktop from '../locales/it-IT/desktop.json';
import itGameMap from '../locales/it-IT/game_map.json';
import itGameTools from '../locales/it-IT/game_tools.json';
import itLabs from '../locales/it-IT/labs.json';
import itMobileMaps from '../locales/it-IT/mobile_maps.json';
import itUi from '../locales/it-IT/ui.json';
import itVideo from '../locales/it-IT/video.json';
import itWebsite from '../locales/it-IT/website.json';
import itWiki from '../locales/it-IT/wiki.json';
import jaAssistant from '../locales/ja-JP/assistant.json';
import jaBorderlands3SkillTrees from '../locales/ja-JP/borderlands_3_skill_trees_localization.json';
import jaCommon from '../locales/ja-JP/common.json';
import jaDesktop from '../locales/ja-JP/desktop.json';
import jaGameMap from '../locales/ja-JP/game_map.json';
import jaGameTools from '../locales/ja-JP/game_tools.json';
import jaLabs from '../locales/ja-JP/labs.json';
import jaMobileMaps from '../locales/ja-JP/mobile_maps.json';
import jaUi from '../locales/ja-JP/ui.json';
import jaVideo from '../locales/ja-JP/video.json';
import jaWebsite from '../locales/ja-JP/website.json';
import jaWiki from '../locales/ja-JP/wiki.json';
import koAssistant from '../locales/ko-KR/assistant.json';
import koBorderlands3SkillTrees from '../locales/ko-KR/borderlands_3_skill_trees_localization.json';
import koCommon from '../locales/ko-KR/common.json';
import koDesktop from '../locales/ko-KR/desktop.json';
import koGameMap from '../locales/ko-KR/game_map.json';
import koGameTools from '../locales/ko-KR/game_tools.json';
import koLabs from '../locales/ko-KR/labs.json';
import koMobileMaps from '../locales/ko-KR/mobile_maps.json';
import koUi from '../locales/ko-KR/ui.json';
import koVideo from '../locales/ko-KR/video.json';
import koWebsite from '../locales/ko-KR/website.json';
import koWiki from '../locales/ko-KR/wiki.json';
import plAssistant from '../locales/pl-PL/assistant.json';
import plBorderlands3SkillTrees from '../locales/pl-PL/borderlands_3_skill_trees_localization.json';
import plCommon from '../locales/pl-PL/common.json';
import plDesktop from '../locales/pl-PL/desktop.json';
import plGameMap from '../locales/pl-PL/game_map.json';
import plGameTools from '../locales/pl-PL/game_tools.json';
import plLabs from '../locales/pl-PL/labs.json';
import plMobileMaps from '../locales/pl-PL/mobile_maps.json';
import plUi from '../locales/pl-PL/ui.json';
import plVideo from '../locales/pl-PL/video.json';
import plWebsite from '../locales/pl-PL/website.json';
import plWiki from '../locales/pl-PL/wiki.json';
import ptAssistant from '../locales/pt-BR/assistant.json';
import ptBorderlands3SkillTrees from '../locales/pt-BR/borderlands_3_skill_trees_localization.json';
import ptCommon from '../locales/pt-BR/common.json';
import ptDesktop from '../locales/pt-BR/desktop.json';
import ptGameMap from '../locales/pt-BR/game_map.json';
import ptGameTools from '../locales/pt-BR/game_tools.json';
import ptLabs from '../locales/pt-BR/labs.json';
import ptMobileMaps from '../locales/pt-BR/mobile_maps.json';
import ptUi from '../locales/pt-BR/ui.json';
import ptVideo from '../locales/pt-BR/video.json';
import ptWebsite from '../locales/pt-BR/website.json';
import ptWiki from '../locales/pt-BR/wiki.json';
import thAssistant from '../locales/th-TH/assistant.json';
import thBorderlands3SkillTrees from '../locales/th-TH/borderlands_3_skill_trees_localization.json';
import thCommon from '../locales/th-TH/common.json';
import thDesktop from '../locales/th-TH/desktop.json';
import thGameMap from '../locales/th-TH/game_map.json';
import thGameTools from '../locales/th-TH/game_tools.json';
import thLabs from '../locales/th-TH/labs.json';
import thMobileMaps from '../locales/th-TH/mobile_maps.json';
import thUi from '../locales/th-TH/ui.json';
import thVideo from '../locales/th-TH/video.json';
import thWebsite from '../locales/th-TH/website.json';
import thWiki from '../locales/th-TH/wiki.json';
import trAssistant from '../locales/tr-TR/assistant.json';
import trBorderlands3SkillTrees from '../locales/tr-TR/borderlands_3_skill_trees_localization.json';
import trCommon from '../locales/tr-TR/common.json';
import trDesktop from '../locales/tr-TR/desktop.json';
import trGameMap from '../locales/tr-TR/game_map.json';
import trGameTools from '../locales/tr-TR/game_tools.json';
import trLabs from '../locales/tr-TR/labs.json';
import trMobileMaps from '../locales/tr-TR/mobile_maps.json';
import trUi from '../locales/tr-TR/ui.json';
import trVideo from '../locales/tr-TR/video.json';
import trWebsite from '../locales/tr-TR/website.json';
import trWiki from '../locales/tr-TR/wiki.json';
import zhAssistant from '../locales/zh-CN/assistant.json';
import zhBorderlands3SkillTrees from '../locales/zh-CN/borderlands_3_skill_trees_localization.json';
import zhCommon from '../locales/zh-CN/common.json';
import zhDesktop from '../locales/zh-CN/desktop.json';
import zhGameMap from '../locales/zh-CN/game_map.json';
import zhGameTools from '../locales/zh-CN/game_tools.json';
import zhLabs from '../locales/zh-CN/labs.json';
import zhMobileMaps from '../locales/zh-CN/mobile_maps.json';
import zhUi from '../locales/zh-CN/ui.json';
import zhVideo from '../locales/zh-CN/video.json';
import zhWebsite from '../locales/zh-CN/website.json';
import zhWiki from '../locales/zh-CN/wiki.json';

import type { defaultLanguage, LanguageCode } from './languages';

type DefaultResources = {
    labs: typeof enLabs;
    assistant: typeof enAssistant;
    common: typeof enCommon;
    desktop: typeof enDesktop;
    game_map: typeof enGameMap;
    game_tools: typeof enGameTools;
    ui: typeof enUi;
    mobile_maps: typeof enMobileMaps;
    video: typeof enVideo;
    website: typeof enWebsite;
    wiki: typeof enWiki;
    borderlands_3_skill_trees_localization: typeof enBorderlands3SkillTrees;
};

type Resources = {
    [Code in LanguageCode]: Code extends typeof defaultLanguage
        ? DefaultResources
        : Partial<Record<keyof DefaultResources, Record<string, unknown>>>;
};

export const resources: Resources = {
    en: {
        labs: enLabs,
        assistant: enAssistant,
        common: enCommon,
        desktop: enDesktop,
        game_map: enGameMap,
        game_tools: enGameTools,
        ui: enUi,
        mobile_maps: enMobileMaps,
        video: enVideo,
        website: enWebsite,
        wiki: enWiki,
        borderlands_3_skill_trees_localization: enBorderlands3SkillTrees,
    },
    de: {
        labs: deLabs,
        assistant: deAssistant,
        common: deCommon,
        desktop: deDesktop,
        game_map: deGameMap,
        game_tools: deGameTools,
        ui: deUi,
        mobile_maps: deMobileMaps,
        video: deVideo,
        website: deWebsite,
        wiki: deWiki,
        borderlands_3_skill_trees_localization: deBorderlands3SkillTrees,
    },
    es: {
        labs: esLabs,
        assistant: esAssistant,
        common: esCommon,
        desktop: esDesktop,
        game_map: esGameMap,
        game_tools: esGameTools,
        ui: esUi,
        mobile_maps: esMobileMaps,
        video: esVideo,
        website: esWebsite,
        wiki: esWiki,
        borderlands_3_skill_trees_localization: esBorderlands3SkillTrees,
    },
    fr: {
        labs: frLabs,
        assistant: frAssistant,
        common: frCommon,
        desktop: frDesktop,
        game_map: frGameMap,
        game_tools: frGameTools,
        ui: frUi,
        mobile_maps: frMobileMaps,
        video: frVideo,
        website: frWebsite,
        wiki: frWiki,
        borderlands_3_skill_trees_localization: frBorderlands3SkillTrees,
    },
    hi: {
        labs: hiLabs,
        assistant: hiAssistant,
        common: hiCommon,
        desktop: hiDesktop,
        game_map: hiGameMap,
        game_tools: hiGameTools,
        ui: hiUi,
        mobile_maps: hiMobileMaps,
        video: hiVideo,
        website: hiWebsite,
        wiki: hiWiki,
        borderlands_3_skill_trees_localization: hiBorderlands3SkillTrees,
    },
    id: {
        labs: idLabs,
        assistant: idAssistant,
        common: idCommon,
        desktop: idDesktop,
        game_map: idGameMap,
        game_tools: idGameTools,
        ui: idUi,
        mobile_maps: idMobileMaps,
        video: idVideo,
        website: idWebsite,
        wiki: idWiki,
        borderlands_3_skill_trees_localization: idBorderlands3SkillTrees,
    },
    it: {
        labs: itLabs,
        assistant: itAssistant,
        common: itCommon,
        desktop: itDesktop,
        game_map: itGameMap,
        game_tools: itGameTools,
        ui: itUi,
        mobile_maps: itMobileMaps,
        video: itVideo,
        website: itWebsite,
        wiki: itWiki,
        borderlands_3_skill_trees_localization: itBorderlands3SkillTrees,
    },
    ja: {
        labs: jaLabs,
        assistant: jaAssistant,
        common: jaCommon,
        desktop: jaDesktop,
        game_map: jaGameMap,
        game_tools: jaGameTools,
        ui: jaUi,
        mobile_maps: jaMobileMaps,
        video: jaVideo,
        website: jaWebsite,
        wiki: jaWiki,
        borderlands_3_skill_trees_localization: jaBorderlands3SkillTrees,
    },
    ko: {
        labs: koLabs,
        assistant: koAssistant,
        common: koCommon,
        desktop: koDesktop,
        game_map: koGameMap,
        game_tools: koGameTools,
        ui: koUi,
        mobile_maps: koMobileMaps,
        video: koVideo,
        website: koWebsite,
        wiki: koWiki,
        borderlands_3_skill_trees_localization: koBorderlands3SkillTrees,
    },
    pl: {
        labs: plLabs,
        assistant: plAssistant,
        common: plCommon,
        desktop: plDesktop,
        game_map: plGameMap,
        game_tools: plGameTools,
        ui: plUi,
        mobile_maps: plMobileMaps,
        video: plVideo,
        website: plWebsite,
        wiki: plWiki,
        borderlands_3_skill_trees_localization: plBorderlands3SkillTrees,
    },
    pt: {
        labs: ptLabs,
        assistant: ptAssistant,
        common: ptCommon,
        desktop: ptDesktop,
        game_map: ptGameMap,
        game_tools: ptGameTools,
        ui: ptUi,
        mobile_maps: ptMobileMaps,
        video: ptVideo,
        website: ptWebsite,
        wiki: ptWiki,
        borderlands_3_skill_trees_localization: ptBorderlands3SkillTrees,
    },
    th: {
        labs: thLabs,
        assistant: thAssistant,
        common: thCommon,
        desktop: thDesktop,
        game_map: thGameMap,
        game_tools: thGameTools,
        ui: thUi,
        mobile_maps: thMobileMaps,
        video: thVideo,
        website: thWebsite,
        wiki: thWiki,
        borderlands_3_skill_trees_localization: thBorderlands3SkillTrees,
    },
    tr: {
        labs: trLabs,
        assistant: trAssistant,
        common: trCommon,
        desktop: trDesktop,
        game_map: trGameMap,
        game_tools: trGameTools,
        ui: trUi,
        mobile_maps: trMobileMaps,
        video: trVideo,
        website: trWebsite,
        wiki: trWiki,
        borderlands_3_skill_trees_localization: trBorderlands3SkillTrees,
    },
    zh: {
        labs: zhLabs,
        assistant: zhAssistant,
        common: zhCommon,
        desktop: zhDesktop,
        game_map: zhGameMap,
        game_tools: zhGameTools,
        ui: zhUi,
        mobile_maps: zhMobileMaps,
        video: zhVideo,
        website: zhWebsite,
        wiki: zhWiki,
        borderlands_3_skill_trees_localization: zhBorderlands3SkillTrees,
    },
} as const;

export type WandNamespace = keyof (typeof resources)[typeof defaultLanguage];
export type Wandi18nResource<Ns extends WandNamespace> = (typeof resources)[typeof defaultLanguage][Ns];

type KeyPath<T extends string, K extends string> = `${T}${'' extends T ? '' : '.'}${K}`;
export type KeyPaths<T extends object, P extends string = '', IncludeBranches extends boolean = true> = {
    [K in keyof T]-?: K extends string
        ? NonNullable<T[K]> extends object
            ?
                  | (IncludeBranches extends true ? KeyPath<P, K> : never)
                  | KeyPaths<NonNullable<T[K]>, KeyPath<P, K>, IncludeBranches>
            : KeyPath<P, K>
        : never;
}[keyof T & string];
export type LeafKeyPaths<T extends object, P extends string = ''> = KeyPaths<T, P, false>;

export type Wandi18nResourcePath<Ns extends WandNamespace> = KeyPaths<Wandi18nResource<Ns>>;
